import { isNil } from "../base.mjs";
import { assertCanHandle } from "../errors.mjs";
//#region src/async-utils/timed-map.ts
const TimedMapCallbackAction = {
	REMOVE_FROM_MAP: 0,
	EXTEND_LIFETIME: 1
};
var TimedMap = class {
	params;
	entriesMap = /* @__PURE__ */ new Map();
	setIntervalId = void 0;
	constructor(params) {
		this.params = params;
		this.startTimeoutCheck();
	}
	set(entryKey, entry) {
		this.entriesMap.set(entryKey, {
			value: entry,
			deadline: this.getNewDeadline()
		});
	}
	touch(entryKey) {
		const timedValue = this.entriesMap.get(entryKey);
		if (isNil(timedValue)) throw new Error(`Key expected to be present: ${JSON.stringify(entryKey)}`);
		timedValue.deadline = this.getNewDeadline();
	}
	get(entryKey) {
		return this.entriesMap.get(entryKey)?.value;
	}
	delete(entryKey) {
		this.entriesMap.delete(entryKey);
	}
	getEntries() {
		return this.entriesMap;
	}
	size() {
		return this.entriesMap.size;
	}
	clear() {
		this.entriesMap.clear();
	}
	stopTimeoutCheck() {
		if (!isNil(this.setIntervalId)) clearInterval(this.setIntervalId);
	}
	startTimeoutCheck() {
		if (isNil(this.setIntervalId)) this.setIntervalId = setInterval(() => this.timeoutCheck(), this.params.timeoutCheckIntervalMs);
	}
	getNewDeadline() {
		return performance.now() + this.params.timeoutMs;
	}
	timeoutCheck() {
		const now = performance.now();
		const keysToRemove = [];
		this.entriesMap.forEach((value, key) => this.checkKeyToDelete(now, value, key, keysToRemove));
		for (const key of keysToRemove) this.entriesMap.delete(key);
	}
	checkKeyToDelete(now, value, key, keysToRemove) {
		if (value.deadline > now) return;
		let action = TimedMapCallbackAction.REMOVE_FROM_MAP;
		if (!isNil(this.params.timeoutCb)) this.executeSafe(() => {
			action = this.params.timeoutCb(key, value.value);
		});
		switch (action) {
			case TimedMapCallbackAction.REMOVE_FROM_MAP:
				keysToRemove.push(key);
				break;
			case TimedMapCallbackAction.EXTEND_LIFETIME:
				value.deadline = this.getNewDeadline();
				break;
			default: throw new Error("Unhandled TimedMapCallbackAction");
		}
	}
	executeSafe(fn) {
		try {
			fn();
		} catch (e) {
			assertCanHandle(e, () => {
				return true;
			});
		}
	}
};
//#endregion
export { TimedMap, TimedMapCallbackAction };
